import { combineReducers } from "redux";
import { fetchProductsData } from "./reducer";

export default combineReducers({
  fetchProductsData
});
